import { useState } from "react";
import "./Optin.css";

function Optin() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="optin">
      <p>Want to be the first to know when we launch?</p>
      <button onClick={() => setIsOpen((prev) => !prev)}>Notify Me</button>

      {isOpen && (
        <div id="modal" className="modal is_open" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div className="wrapper">
            <h3 id="modal-title">Enter Your Email</h3>
            <button
              className="modal-close"
              aria-label="Close"
              onClick={() => setIsOpen(false)}
            >
              ✕
            </button>
            <div className="clearfix">
              <div className="col-8" />
              <div className="col-3" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Optin;
